import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import type { WorkflowAction, WorkflowActionType } from '../../utils/workflow-action-catalog';

export interface WorkflowActionConfigOverlayData {
  action: WorkflowAction;
}

export type WorkflowActionConfigOverlayResult = WorkflowAction | null;

@Component({
  selector: 'app-workflow-action-config-overlay',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './workflow-action-config-overlay.html',
  styleUrl: './workflow-action-config-overlay.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkflowActionConfigOverlayComponent {
  private readonly dialogRef = inject(DialogRef<WorkflowActionConfigOverlayResult>);
  private readonly dialogData = inject<WorkflowActionConfigOverlayData>(DIALOG_DATA);

  readonly action = this.dialogData.action;
  readonly draft = signal<Record<string, string>>({ ...this.action.config });

  readonly actionType = computed(() => this.action.type);

  updateConfig(key: string, value: string): void {
    this.draft.update((current) => ({ ...current, [key]: value }));
  }

  close(): void {
    this.dialogRef.close(null);
  }

  save(): void {
    this.dialogRef.close({
      ...this.action,
      config: { ...this.draft() },
    });
  }

  isType(type: WorkflowActionType): boolean {
    return this.action.type === type;
  }
}
